import React from 'react'
import Chart from 'chart.js/auto'
import { Bar } from 'react-chartjs-2'

const UserMiningChart = ({ classes, userInfo }) => {
  const chartDates = [...userInfo.dailyStepChartData.map((item) => item.date)]
  const chartData = [...userInfo.dailyStepChartData.map((item) => item.steps)]

  return (
    <div className="relative mb-24 w-full">
      {/* <!-- Price History --> */}
      <div className="tab-pane fade">
        <div className={classes}>
          {/* <!-- Period / Stats --> */}
          <div className="mb-10 flex flex-wrap items-center">
            <select
              disabled
              className="hidden dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 mr-8 min-w-[12rem] rounded-lg py-3.5 text-sm dark:text-white lg:block"
            >
              <option value="all-time">Last 30Days</option>
            </select>

            <div className="py-2">
              <span className="mr-4 inline-block align-middle">
                <span className="block text-sm font-bold dark:text-white">Total Steps</span>
                <span className="text-green block text-sm font-bold">{userInfo.totalSteps}</span>
              </span>

              <span className="inline-block align-middle">
                <span className="block text-sm font-bold dark:text-white">
                  Total Mining<span className="text-[10px] text-jacarta-300">(WKM)</span>
                </span>
                <span className="text-green block text-sm font-bold">{userInfo.wkmEarnAmount}</span>
              </span>
            </div>
          </div>

          {/* <!-- Chart --> */}
          <div className="chart-container relative h-80 w-full">
            <Bar
              data={{
                labels: [...chartDates],
                datasets: [
                  {
                    type: 'bar',
                    label: 'Steps',
                    backgroundColor: '#E7E8EC',
                    data: [...chartData],
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                responsive: true,
                interaction: {
                  intersect: false,
                  mode: 'index',
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                  },
                  y: {
                    grid: {
                      display: false,
                    },
                    ticks: {
                      stepSize: 100,
                    },
                  },
                },
                plugins: {
                  legend: { display: false },
                  decimation: {
                    enabled: true,
                  },
                  tooltip: {
                    usePointStyle: true,
                    position: 'nearest',
                    backgroundColor: '#131740',
                    titleAlign: 'center',
                    bodyAlign: 'center',
                    footerAlign: 'center',
                    padding: 12,
                    displayColors: false,
                    yAlign: 'bottom',
                  },
                },
                animation: false,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserMiningChart
